var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 181 181.856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crayon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M116.858 15.1082C127.66 15.1082 136.417 23.8649 136.417 34.6668V160.798C136.417 171.599 127.66 180.355 116.858 180.355H21.0586C10.2572 180.355 1.50022 171.599 1.5 160.798V34.6668C1.50004 23.8649 10.257 15.1082 21.0586 15.1082H116.858Z",
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, #5A557C)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.7575 53.4622C66.7208 50.407 71.1832 50.4039 73.152 53.4524H73.153L73.1667 53.4719L73.1735 53.4827C78.0083 61.0088 87.4749 64.0874 95.8112 60.845L95.8337 60.8362L95.8425 60.8333C99.2246 59.5158 102.835 62.1324 102.64 65.7522L102.641 65.7532L102.64 65.762C102.64 65.7659 102.641 65.7698 102.64 65.7737L102.639 65.7825C102.123 74.7256 107.986 82.7923 116.652 85.0608C120.173 85.9828 121.557 90.2414 119.251 93.0569H119.25C113.57 99.9879 113.57 109.964 119.25 116.895C121.534 119.683 120.199 123.884 116.753 124.86L116.752 124.861L116.703 124.877L116.652 124.891C108.121 127.124 102.306 134.975 102.62 143.75L102.64 144.168V144.179L102.641 144.19V144.198C102.837 147.818 99.2261 150.436 95.8434 149.118V149.117L95.8307 149.114L95.82 149.11C87.4815 145.862 78.0093 148.939 73.1725 156.468L73.1599 156.489C71.1965 159.544 66.733 159.548 64.7643 156.498L64.7516 156.48L64.7448 156.468C59.9084 148.939 50.4359 145.862 42.0974 149.11L42.0837 149.116L42.0749 149.118C38.6923 150.436 35.0816 147.818 35.277 144.198V144.18L35.278 144.169C35.7949 135.226 29.9315 127.158 21.2653 124.89C17.744 123.968 16.361 119.71 18.6677 116.895L18.9294 116.568C24.3455 109.653 24.2583 99.8797 18.6677 93.0569C16.3812 90.2666 17.7197 86.0611 21.1706 85.0882H21.1716L21.2184 85.0735L21.2663 85.0608C29.9322 82.7924 35.7952 74.7254 35.278 65.7825L35.277 65.7718V65.7522C35.0829 62.1327 38.6925 59.5159 42.0749 60.8333H42.0739L42.0866 60.8382L42.0974 60.8421C50.4355 64.0899 59.9081 61.0115 64.7448 53.4827L64.7575 53.4622Z",
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, #5A557C)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.5 104.976C80.1302 104.976 99 112.13 99 94.5C90 80.5 86.5888 73.0532 68.9586 73.0532C51.3284 73.0532 37.0363 87.3453 37.0363 104.976C37.0363 122.606 44.8698 104.976 62.5 104.976Z",
    fill: "var(--fill-0, #F9ED80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M68.9582 71.5532C87.4167 71.5532 102.381 86.5167 102.381 104.975C102.381 123.434 87.4168 138.398 68.9582 138.398C50.4998 138.398 35.5363 123.434 35.5363 104.975C35.5365 86.5168 50.4999 71.5535 68.9582 71.5532Z",
    stroke: "var(--stroke-0, #5A557C)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M92.5364 69.2888C92.5364 69.2888 91.069 78.2914 81.793 89.9715C80.634 91.4308 80.7598 93.53 82.0775 94.8479L86.1521 98.9226C87.4698 100.24 89.5692 100.366 91.0286 99.2071C102.709 89.931 111.711 88.4636 111.711 88.4636L106.511 74.4896L92.5364 69.2888Z",
    fill: "var(--fill-0, #E9B336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M106.511 74.4896L103.578 73.398L107.687 84.4395C107.687 84.4395 98.6845 85.9069 87.0044 95.1829C85.5451 96.3419 83.4459 96.2161 82.128 94.8984L86.1521 98.9226C87.4698 100.24 89.5692 100.366 91.0286 99.2071C102.709 89.931 111.711 88.4636 111.711 88.4636L106.511 74.4896Z",
    fill: "var(--fill-0, #C89439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M151.357 5.95918L167.31 13.6904L175.041 29.6431L167.034 37.6495L151.148 29.8525L143.351 13.9658L151.357 5.95918Z",
    fill: "var(--fill-0, #BF8B29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M167.31 13.6904L164.599 12.3767L171.016 25.6189L163.01 33.6256L149.823 27.1531L151.147 29.8525L167.034 37.6497L175.041 29.6431L167.31 13.6904Z",
    fill: "var(--fill-0, #966B18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M106.511 50.8055L121.681 59.3191L130.195 74.4894L122.188 82.4958L106.511 74.4894L98.5042 58.8121L106.511 50.8055Z",
    fill: "var(--fill-0, #BF8B29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M121.681 59.3191L119.103 57.8725L126.17 70.4652L118.164 78.4717L105.15 71.8258L106.511 74.4896L122.188 82.4958L130.195 74.4894L121.681 59.3191Z",
    fill: "var(--fill-0, #966B18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M163.442 1.60083L179.399 17.5582C181.534 19.6926 181.534 23.1501 179.399 25.2845L175.041 29.6431L151.357 5.95918L155.715 1.60063C157.85 -0.533576 161.307 -0.533576 163.442 1.60083Z",
    fill: "var(--fill-0, #FFCB6F)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M179.399 17.5582L175.375 13.534C177.509 15.6682 177.509 19.126 175.375 21.2604L171.017 25.6189L175.041 29.6431L179.399 25.2845C181.534 23.1503 181.534 19.6924 179.399 17.5582Z",
    fill: "var(--fill-0, #E9B336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M106.505 50.8058L143.339 13.9716L167.019 37.6519L130.185 74.486L106.505 50.8058Z",
    fill: "var(--fill-0, #FFCB6F)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M126.161 70.464L162.995 33.6298L167.018 37.6533L130.184 74.4875L126.161 70.464Z",
    fill: "var(--fill-0, #E9B336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M98.5042 58.8121L122.188 82.4958L116.221 88.4624C114.975 89.7083 112.957 89.7083 111.711 88.4624L92.5374 69.2888C91.2915 68.0429 91.2915 66.0246 92.5374 64.7785L98.5042 58.8121Z",
    fill: "var(--fill-0, #FFCB6F)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M118.164 78.4717L112.197 84.4383C110.951 85.6841 108.933 85.6841 107.687 84.4383L111.711 88.4624C112.957 89.7083 114.975 89.7083 116.221 88.4624L122.188 82.4958L118.164 78.4717Z",
    fill: "var(--fill-0, #E9B336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M144.523 51.9906C152.461 44.0526 155.421 34.1426 151.135 29.8559C146.848 25.5693 136.938 28.5293 129 36.4673C121.062 44.4053 118.102 54.3153 122.389 58.602C126.675 62.8886 136.585 59.9286 144.523 51.9906Z",
    fill: "var(--fill-0, #E9B336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcon);
export default __webpack_public_path__ + "static/media/color-icon.de6700942935f0f190e08fd965af1a54.svg";
export { ForwardRef as ReactComponent };